import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SHARE_PIPES } from './pipes';
import { SHARE_MODULES } from './modules';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ...SHARE_MODULES,
  ],
  declarations: [
  ],
  exports: [
    RouterModule,
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ...SHARE_PIPES,
    ...SHARE_MODULES,
  ],
})
export class SharedModule { }
